/**
 * Created by jcorrea on 24/07/17.
 */

angular
	.module('servicepro.workordereditor', [
		'ngResource',
		'ng-sortable',
		'ui.bootstrap'
	]);